// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"e162faec","513":"20704289","703":"d79cad8e","787":"be8ece78"}[chunkId] + ".chunk.js";
};